import { employeeReduxConstants } from '@/constants';
import { PlaceEmployee } from '@/types/state/shared';

export const employeeActions = {
  setEmployees,
};

function setEmployees({ ids, all }: { ids: Array<number>; all: { [id: number]: PlaceEmployee } }) {
  return { type: employeeReduxConstants.SET_EMPLOYEES, employees: { ids, all } };
}
